"use client"

import { createContext, useContext } from "react"

export type ConsentState = "granted" | "denied" | "pending"

export const ConsentContext = createContext<{
	consent: ConsentState
	accept: () => void
	decline: () => void
}>({
	consent: "pending",
	accept: () => {},
	decline: () => {},
})

export function useConsent() {
	return useContext(ConsentContext)
}
